/**
 * Local development: inject a static JWT for all API calls that use `getProductApiBearer()`
 * or Ginja platform helpers, without relying on SSO cookies or `/me/access`.
 *
 * Set in `.env.local` (gitignored):
 *   VITE_DEV_BEARER_TOKEN=eyJ...
 *
 * **Only active when `import.meta.env.DEV` is true** (stripped from production builds in practice;
 * still remove the variable from any hosted env before deploy).
 */
export function getDevBearerOverride(): string | null {
  if (!import.meta.env.DEV) return null;
  const raw = import.meta.env.VITE_DEV_BEARER_TOKEN;
  if (typeof raw !== "string") return null;
  const t = raw.trim();
  return t.length > 0 ? t : null;
}
